export const CONFIRM_BOOKING_NODE_TYPE = "confirm_booking";
export const CONFIRM_BOOKING_OUTPUTS = [
  { id: "confirmed", label: "Confirmed" },
  { id: "hold_expired", label: "Hold expired" },
  { id: "processing_failed", label: "Processing failed" },
];
const keyPattern = /^[a-z][a-z0-9_]*(\.[a-z][a-z0-9_]*)+$/;
export const createConfirmBookingConfig = () => ({
  schemaVersion: 1,
  commerceTransactionSessionKey: "",
  createPayableOrder: false,
});
export const validateConfirmBookingConfig = config => {
  if (Number(config?.schemaVersion) !== 1) return { isValid: false, message: "Confirm Booking schema version must be 1." };
  const key = String(config?.commerceTransactionSessionKey || "").trim();
  if (key && !keyPattern.test(key)) return { isValid: false, message: "Commerce transaction session key is invalid." };
  return { isValid: true, message: "" };
};
